import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=009b89c2&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=ts&"
export * from "./AddressForm.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AddressForm.vue?vue&type=style&index=1&id=009b89c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b89c2",
  null
  
)

export default component.exports